<main>
  <loading-overlay [isLoading]="isLoading" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ getCategoryTypeTranslation() }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Create' | translateWF: 'Create'" icon="pi pi-plus" (click)="openCategoriesModal()" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="grid-12 gap-[2rem]">
        <div class="span-12">
          <p-table
            dataKey="id"
            [value]="categories"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 20]"
            [expandedRowKeys]="expandedRows"
            (onRowExpand)="onCategoryExpand($event)"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 5rem"></th>
                <th pSortableColumn="code">
                  {{ 'Common_Table_Header_Category' | translateWF: 'Category' }}
                  <p-sortIcon field="code" />
                </th>
                @if (categoryType === 'Fabric') {
                  <th>
                    {{ 'Common_Table_Header_MachineType' | translateWF: 'Machine Type' }}
                  </th>
                }
                <th></th>
              </tr>
            </ng-template>
            <!-- Level 1: categories -->
            <ng-template pTemplate="body" let-category let-expanded="expanded">
              <tr>
                <td>
                  <p-button
                    type="button"
                    pRipple
                    [pRowToggler]="category"
                    [text]="true"
                    [rounded]="true"
                    [plain]="true"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  />
                </td>
                <td class="truncate">{{ category.code }} - {{ category.name | localized }}</td>
                @if (categoryType === 'Fabric') {
                  <td class="truncate">
                    {{ getMachineTypeById(category.machineTypeReference) }}
                  </td>
                }
                <td class="!text-end">
                  <p-button variant="text" icon="pi pi-pencil" (click)="openCategoriesModal(category)" />
                  <p-button variant="text" icon="pi pi-trash" [disabled]="!canEdit()" (click)="deletePopup($event, category)" />
                  <p-button variant="text" icon="pi pi-plus" [disabled]="!canEdit()" (click)="openCategoriesModal(category, true)" />
                </td>
              </tr>
            </ng-template>
            <!-- Level 2: subcategories -->
            <ng-template #expandedrow let-category>
              <tr>
                <td colspan="4" class="!py-0 !px-0 !border-none">
                  <p-table [value]="category.subcategories" dataKey="id" [expandedRowKeys]="expandedRows" (onRowExpand)="onCategoryExpand($event)">
                    <ng-template #body let-subcategory let-expanded="expanded">
                      <tr>
                        <td style="width: 1rem"></td>
                        <td style="width: 5rem">
                          <p-button
                            type="button"
                            pRipple
                            [pRowToggler]="subcategory"
                            [text]="true"
                            [rounded]="true"
                            [plain]="true"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                          />
                        </td>
                        <td>
                          {{ subcategory.code }} -
                          {{ subcategory.name | localized }}
                        </td>
                        <td class="!text-end">
                          <p-button variant="text" icon="pi pi-pencil" (click)="openCategoriesModal(subcategory)" />
                          <p-button variant="text" icon="pi pi-trash" [disabled]="!canEdit()" (click)="deletePopup($event, subcategory)" />
                          <p-button variant="text" icon="pi pi-plus" [disabled]="levels == 2 || !canEdit()" (click)="openCategoriesModal(subcategory, true)" />
                        </td>
                      </tr>
                    </ng-template>
                    <!-- Level 3: sub-subcategories -->
                    <ng-template #expandedrow let-subcategory>
                      <tr>
                        <td colspan="4" class="!py-0 !px-0 !border-none">
                          <p-table [value]="subcategory.subcategories" dataKey="id">
                            <ng-template pTemplate="body" let-sub_subcategory>
                              <tr>
                                <td style="width: 7rem"></td>
                                <td>
                                  {{ sub_subcategory.code }} -
                                  {{ sub_subcategory.name | localized }}
                                </td>
                                <td class="!text-end">
                                  <p-button variant="text" icon="pi pi-pencil" (click)="openCategoriesModal(sub_subcategory)" />
                                  <p-button variant="text" icon="pi pi-trash" [disabled]="!canEdit()" (click)="deletePopup($event, sub_subcategory)" />
                                  <p-button variant="text" icon="pi pi-plus" disabled="true" />
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template #emptymessage>
                              <tr>
                                <td style="width: 7rem"></td>
                                <td colspan="6" class="font-semibold">
                                  {{ 'Common_Table_Empty_Categories' | translateWF: 'There are no subcategories for this category yet.' }}
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                      <tr>
                        <td style="width: 5rem"></td>
                        <td colspan="6" class="font-semibold">
                          {{ 'Common_Table_Empty_Categories' | translateWF: 'There are no subcategories for this category yet.' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>
  </div>
  <p-toast />
  <p-confirmdialog />
</main>
